import { HTTP } from 'meteor/http';
import { Promise } from 'meteor/promise';

/** HttpPromise provides a promise wrapper for the HTTP request API on the client and server.
 *
 * @param {string} method - The HTTP method to use, such as "GET", "POST", or "HEAD".
 * @param {string} url - The URL to retrieve.
 * @param {object} options - Https://docs.meteor.com/api/http.html.
 */

export default (method, url, options) =>
  new Promise((resolve, reject) => {
    HTTP.call(method, url, options, (error, result) => {
      if (error) reject(error);
      else if (result) resolve(result);
    });
  });
